import React, { Component } from 'react';
import fb from '../images/Facebook_black 1.png';
import tw from '../images/Twitter_black 1.png';
import yu from '../images/Youtube_black 1.png';
import md from '../images/Medium_black 1.png';


class footer extends Component {
  // Constructor to initialize state
  constructor(props) {
    super(props);
    }


  // Render method to display the component
  render() {
    return (
      <footer className="bg-orenge text-white py-6">
        <div className="max-w-screen-xl mx-auto px-4">
          <div className="flex justify-between items-center">
            <div>
              <p>&copy; 2025 runners. Powered by kalingarayanrunners</p>
            </div>
            <div className='flex space-x-4'>
              <a href="#" className="text-blue-400 hover:text-blue-600"><img src={fb}/></a> 
              <a href="#" className="text-blue-400 hover:text-blue-600"><img src={tw}/></a>
              <a href="#" className="text-blue-400 hover:text-blue-600"><img src={yu}/></a>
              <a href="#" className="text-blue-400 hover:text-blue-600"><img src={md}/></a>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default footer;
